import { getPremiumContext } from "@memorang/helpers/bundle";
import type { ExamDetails } from "@memorang/types";

const physicianRoles = [
	"orthopaedic_surgeon",
	"physician_associate",
	"resident",
	"fellow",
];
export const getDisplayName = (
	role?: string,
	firstName?: string,
	lastName?: string,
) => {
	const isPhysician = role && physicianRoles.includes(role);
	return isPhysician ? `Dr. ${lastName || ""}` : firstName || "";
};

export const getPurchasedExams = (examsList: ExamDetails[]) => {
	const purchasedExams = examsList?.filter(({ exam: { bundles } }) => {
		return bundles.some((item) => getPremiumContext(item.metadata).hasAccess);
	});
	return purchasedExams;
};
